<template>
  <div class="goods-box">
    <el-button
      type="primary"
      size="mini"
      @click="handleAdd"
      style="margin-top: 10px"
      >新增</el-button
    >
    <el-button type="primary" size="mini" @click="onShowProductCoverSetting" style="margin-top: 10px">商品推荐补位</el-button>
    <el-divider></el-divider>
    <el-table
      ref="tableRef"
      :data="goodsData"
      highlight-current-row
      style="width: 100%; margin-top: 10px"
      :max-height="maxHeight"
    >
    <!-- <el-table-column type="index" label="序号" width="80" align="center" /> -->
    <el-table-column type="sort" label="序号" width="140" align="center" >
      <template slot-scope="scope">
        <div class="merchant-name">
          <span class="name">{{ scope.row.sort }}</span>
          <span v-if="scope.row.id">
            <i
              class="el-icon-edit"
              style="margin-left: 10px"
              @click="handleClickSort(scope.row)"
            ></i> 
          </span>
        </div>
      </template>
  </el-table-column>
      <el-table-column label="商品信息" align="center" width="500">
        <template slot-scope="scope">
          <div
            class="goods-info"
            v-if="
              scope.row.goodsSkuName ||
              scope.row.specification ||
              scope.row.factory ||
              scope.row.approvalNumber
            "
          >
            <img
              class="goods-info-left"
              :src="scope.row.goodsSkuImage || avater"
              alt=""
            />
            <div class="goods-info-right">
              <p class="color-26 text-ellipsis">{{ scope.row.goodsSkuName }}</p>
              <p class="color-26 text-ellipsis">{{ scope.row.factory }}</p>
              <p class="color-26">{{ scope.row.specification }}</p>
              <p class="color-26">{{ scope.row.approvalNumber }}</p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="priceRange" label="价格" align="center" />
      <el-table-column prop="saleShopCount" label="在售商家" align="center" />
      <el-table-column label="操作" align="center" width="120" fixed="right">
        <template slot-scope="scope">
          <p
            @click="handleEdit(scope.row)"
            style="cursor: pointer; margin-right: 10px"
          >
            选择商品
        </p>
          <p
            @click="handleDelete(scope.row,scope.$index)"
            :style="{
              color: 'red',
              cursor: 'pointer',
            }"
            >删除</p
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增/编辑 -->
    <DlgAddGoods
      ref="addGoodsRef"
      :type="goodsType"
      :show-shop="showShop"
      @refreshList="getGoodsList"
      :sourceParentPage="'goodsRecommend'"
    />
    <!-- 补位设置 -->
    <el-dialog title="商品补位设置" :visible.sync="showProductCoverSetting" width="70%" @close="onCloseProductCoverSetting">
      <GoodsCoverSetting :visible.sync="showProductCoverSetting"/>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onCloseProductCoverSetting">取消</el-button>
      </span>
    </el-dialog>
    <setSort ref="setSort"  @refreshList="getGoodsList" :appendToBody="true"/>
  </div>
</template>

<script>
import avater from "/public/img/default.png";
import DlgAddGoods from "../components/dlgAddGoods";
import GoodsCoverSetting from "../components/goodsCoverSetting.vue";
import setSort from "../components/setSort";
import {
  getRecommendGoodsList,
  addRecommendGoods,
  updateRecommendGoods,
  deleteRecommendGoods,
} from "@/api/recommendationHome";

export default {
  components: {
    DlgAddGoods,
    GoodsCoverSetting,
    setSort
  },
  data() {
    return {
      avater: avater,
      goodsData: [],
      goodsType: 4,
      showShop: false,
      maxHeight:0,
      showProductCoverSetting: false
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getWindowView();
    this.getGoodsList();
  },
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  methods: {
    handleClickSort(row) {
      this.$refs.setSort.show(row,'goods');
    },
    getWindowView() { 
      let innerHeight = window.innerHeight; //获取页面高度 
      let headHeight = 300; 
      let maxHeight = innerHeight -  headHeight; 
      this.maxHeight = maxHeight;
        // console.log( this.maxHeight)
    },
    getGoodsList() {
      getRecommendGoodsList({ type: this.goodsType }).then((res) => {
        if (res.code == 0) {
          this.goodsData = res.data;
        }
      });
    },
    handleAdd() {
      this.goodsData.push({ add: true });
      // 滚动到底部
      this.$nextTick(() => {
        this.$refs.tableRef.bodyWrapper.scrollTop =
          this.$refs.tableRef.bodyWrapper.scrollHeight;
      });
    },
    handleEdit(row) {
      this.$refs.addGoodsRef.dialogVisible = true;
      this.$refs.addGoodsRef.id = row.id;
    },
    handleDelete(row,index) {
      if (row.add) {
        this.goodsData.splice(index, 1);
        return;
      };
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return deleteRecommendGoods(row.id);
        })
        .then(() => {
          this.getGoodsList();
          this.$message.success("删除成功");
        });
    },
    /** sku补位设置 */
    onShowProductCoverSetting() {
      this.showProductCoverSetting = true
    },
    /**关闭sku补位设置 */
    onCloseProductCoverSetting() {
      this.showProductCoverSetting = false
    }
  },
};
</script>
<style lang="scss" scoped>
.goods-box {
  .goods-info {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    &-left {
      width: 60px;
      height: 60px;
      margin-right: 10px;
    }
    &-right {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 260px;

      .text-ellipsis {
        max-width: 250px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    p {
      margin: 0;
      height: 18px;
    }
    .color-26 {
      color: #262626;
    }
  }
}
</style>
